import { render, staticRenderFns } from "./SkpTerstruktur.vue?vue&type=template&id=7fb3dc23&"
import script from "./SkpTerstruktur.vue?vue&type=script&lang=js&"
export * from "./SkpTerstruktur.vue?vue&type=script&lang=js&"
import style0 from "./SkpTerstruktur.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports